import React, {useState} from 'react';

import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import CreatePartForm, {getCreateFormValidation} from 'molbio/parts/CreatePartForm';
import {ButtonStyle} from 'ui-library/buttons/Button';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import {Optional} from 'util/Types';

interface Props {
  initialFolderId?: string;
  namePlaceholder?: string;
  onRequestClose: () => void;
  onConfirm: ({folderId, name}: {folderId: string; name: string}) => void;
  displaySelectionStart: number;
  displaySelectionEnd: number;
}

function CreatePartModal(props: Props): JSX.Element {
  const [name, setName] = useState<string>(props.namePlaceholder ?? '');
  const [folderId, setFolderId] = useState<Optional<string>>(
    props.initialFolderId ?? FolderDefaults.get(FolderDefaultsKey.INVENTORY)
  );

  const {isValid} = getCreateFormValidation({name, folderId});

  const handleFolderIdChange = (newFolderId: string): void => {
    setFolderId(newFolderId);
    FolderDefaults.set(FolderDefaultsKey.INVENTORY, newFolderId);
  };

  const handleConfirm = (): void => {
    if (folderId) {
      props.onConfirm({folderId, name});
      props.onRequestClose();
    }
  };

  const description =
    'A new part will be created and this region ' +
    `(${props.displaySelectionStart}-${props.displaySelectionEnd}) ` +
    'will be replaced with it.';

  const buttons = [
    {
      text: 'Cancel',
      cancel: true,
    },
    {
      text: 'Replace',
      submit: true,
      style: ButtonStyle.PRIMARY,
      disabled: !isValid,
      onClick: handleConfirm,
    },
  ];

  return (
    <Modal
      title="Replace selection with part"
      showHeaderBorder={false}
      enableRedesign={true}
      onRequestClose={props.onRequestClose}
      buttons={buttons}
    >
      <div className="u-small-padding-bottom">{description}</div>

      <CreatePartForm
        name={name}
        folderId={folderId}
        onNameChange={setName}
        onFolderIdChange={handleFolderIdChange}
      />
    </Modal>
  );
}

CreatePartModal.open = (props: Props): void => {
  const modalProps = {
    ...props,
    onRequestClose: () => {
      ModalContainer.close(CreatePartModal);
    },
  };
  ModalContainer.open(CreatePartModal, <CreatePartModal {...modalProps} />);
};

export default CreatePartModal;
